'use client';

// based on https://www.radix-ui.com/primitives/docs/components/checkbox#api-reference

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cx } from 'class-variance-authority';
import Label from '../../Label';
import styles from './checkbox.module.scss';
import { Checkmark } from '../../../icons';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    id?: string;
    label?: string;
  }
>(({ className, id, label, ...props }, ref) => (
  <div className={styles.container}>
    <CheckboxPrimitive.Root
      ref={ref}
      className={cx(styles.checkbox, className)}
      id={id}
      {...props}
    >
      <CheckboxPrimitive.Indicator className={cx(styles.check)}>
        <Checkmark />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
    {label && (
      <Label size="large" className={styles.label} htmlFor={id}>
        {label}
      </Label>
    )}
  </div>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export default Checkbox;
